import { dynamicBadgeClasses } from '@liquidweb-dev/undercurrent/DynamicBadge';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export type AssetListItemNameProps = StackProps;

export const AssetListItemName = ({ sx, ...rest }: AssetListItemNameProps) => (
	<Stack
		sx={combineSx(
			{
				gap: 100,
				gridArea: 'name',

				// Add margin when preceded by an absolutely positioned dynamic badge
				[`.${dynamicBadgeClasses.root} + &`]: {
					marginLeft: 600,
				},
			},
			sx,
		)}
		{...rest}
	/>
);

export default AssetListItemName;
